import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    fallbackLng: {
      'zh-CN': ['zh-HK', 'en'],                   // ios: "Chinese Simplified"
      'zh-HK': ['zh-CN', 'en'],
      'zh-TW': ['zh-HK', 'zh-CN', 'en'],          // ios: "Chinese Traditional" | "Chinese Traditional (Hong Kong)"
      'zh-Hans': ['zh-CN', 'en'],
      'zh-Hant': ['zh-HK', 'zh-CN', 'en'],
      'default' : ['en']
    },

    // define list of namespaces / regions here
    ns: ['translations', '01', '02', '03', '04', '05'],
    defaultNS: 'translations',
    fallbackNS: 'translations',

    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    detection: {
      caches: []
    },

    react: {
      wait: true
    }
  });


export default i18n;


// WEBPACK FOOTER //
// ./src/scripts/i18n.js